module.exports = __webpack_public_path__ + "img/sprite.b8286b33.svg";